import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {IHistoryRecordViewModel} from "../../../../services/gaming-history/models/record/history-record-view-model.interface";
import {HistoryRecordHeaderBox} from "./boxes/history-record-header.box";
import {HistoryRecordGameNameBox} from "./boxes/game-name/history-record-game-name.box";
import React from "react";
import {CyClass} from "../../../../../common/cy-classes";
import {observer} from "mobx-react";
import {GameRoundIdsContainerBox} from "./boxes/game-round-ids-container/game-round-ids-container.box";
import {HistoryRecordGameRoundIdBox} from "./boxes/game-round-id/history-record-game-round-id.box";

interface GamingHistoryRecordHeaderComponentProps {
    record: IHistoryRecordViewModel;
}

export const HistoryRecordHeaderComponent = observer(
    class HistoryRecordHeaderComponent extends OrbitComponent<GamingHistoryRecordHeaderComponentProps> {
        render() {
            return (
                <HistoryRecordHeaderBox>
                    <HistoryRecordGameNameBox className={CyClass('cy-gaming-history-game-name')}>
                        {this.props.record.gameName}
                    </HistoryRecordGameNameBox>
                    <GameRoundIdsContainerBox>
                        {this.props.record.ids.map(id => <HistoryRecordGameRoundIdBox key={id.text} className={id.cyClass}>{id.text}</HistoryRecordGameRoundIdBox>)}
                    </GameRoundIdsContainerBox>
                </HistoryRecordHeaderBox>
            );
        }
    }
);